export default __webpack_public_path__ + "aa09931681f3615fc1365e7fb8df2624.png";